import {ReduxStateType} from '../store';

export const selectTransactionsReducer = (state: ReduxStateType) =>
  state.transactions;

export const selectTransactionIdMap = (state: ReduxStateType) =>
  state.transactions.transactionIdMap;
